import { useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AccountContentContainer from '../AccountContentContainer';
import usePostLoginHandler from '../usePostLoginHandler';
import getErrorMessage from './getErrorMessage';
import * as styles from './MagicLinkView.module.scss';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';

const MAGIC_LOGIN_MUTATION = gql(/** @complexity 2 */ `
  mutation magicLogin($id: ID!) {
    magicLogin(id: $id) {
      authToken
    }
  }
`);

const MagicLinkView = () => {
  const [errorData, setErrorData] = useState(null);
  const errorMessage = getErrorMessage(errorData, 'magic link');
  const { token } = useParams() as { token: string };
  const [magicLogin] = useMutation(MAGIC_LOGIN_MUTATION, {
    variables: { id: token },
  });

  const postLoginHandler = usePostLoginHandler();

  useEffect(() => {
    magicLogin()
      .then(({ data }) => {
        const authToken = data?.magicLogin?.authToken;

        if (authToken) {
          postLoginHandler(authToken);
        }
      })
      .catch((error) => {
        setErrorData(error);
      });
  }, [magicLogin, postLoginHandler]);

  return errorMessage ? (
    <AccountContentContainer>
      <div className={styles.errorMessage}>{errorMessage}</div>
      <p>
        Please try again with <Link to="/forgot">a new magic link</Link>.
      </p>
    </AccountContentContainer>
  ) : null;
};

export default MagicLinkView;
